import React from "react";

const MatrixMany = ({style = {}, size = "36", className = "", fill = "#73788B", stroke = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill-stroke"
            stroke={stroke}
            strokeWidth={2.5}
            d="M3.25 3.25h11.435v11.435H3.25z"
        />
        <path
            className="u_fill-stroke"
            d="M10.756 6.51 8.387 9.07 7.179 7.764l-.147-.158-.147.158-.387.419-.125.135.125.136 1.742 1.882.147.16.147-.16L11.437 7.2l.126-.136-.126-.136-.387-.418-.147-.158-.147.158Z"
            fill={fill}
            stroke={stroke}
            strokeWidth={0.4}
        />
        <path
            className="u_fill"
            stroke={fill}
            strokeWidth={2.5}
            d="M3.25 21.315h11.435V32.75H3.25zM21.314 3.25h11.435v11.435H21.314zM21.314 21.315h11.435V32.75H21.314z"
        />
    </svg>
);

export default MatrixMany;


